import { EntityRepository, Repository } from "typeorm";
import { Labelling } from "../entities/labelling.entity";

@EntityRepository(Labelling)
export class LabellingRepository extends Repository<Labelling> {

}